import { Button, Card } from 'components/ui'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import CardHeader from './CardHeader'
import CardFooter from './CardFooter'

function Product(props) {
    const {
        headerImageClassName = undefined,
        headerImageAlt = undefined,
        type = undefined,
        btnVariant = undefined,
        form = undefined,
        onClick,
        imgSrc,
        productTitle,
        productCode,
        productPrice,
        productDescription,
        btnText = undefined,
    } = props
    const { t } = useTranslation()

    const PriceAmount = ({ amount }) => {
        return (
            <NumberFormat
                displayType="text"
                value={(Math.round(amount * 100) / 100).toFixed(2)}
                prefix={'$'}
                thousandSeparator={true}
            />
        )
    }
    return (
        <Fragment>
            <Card
                clickable
                className="hover:shadow-lg transition duration-150 ease-in-out dark:border dark:border-gray-600 dark:border-solid"
                header={
                    <CardHeader
                        headerImageClassName={headerImageClassName}
                        headerImageAlt={headerImageAlt}
                        imgSrc={imgSrc}
                    />
                }
                footer={
                    <CardFooter
                        type={type}
                        btnvariant={btnVariant}
                        form={form}
                        onClick={onClick}
                        btnText={btnText}
                    />
                }
                headerClass="p-0 !w-full"
                footerBorder={false}
                headerBorder={false}
            >
                <span className="text-emerald-600 font-semibold">
                    {t('ourProducts:product.publisher', {
                        publisher: productCode,
                    })}
                </span>
                <h4 className="font-bold my-3">{productTitle}</h4>
                <PriceAmount amount={productPrice} />
                <p>{productDescription}</p>
            </Card>
        </Fragment>
    )
}

export default Product
